import * as React from 'react';

import { useHistoryLocation } from '../../navigation';

const VALID_MODES = [
    'signIn',
    'resetPassword',
    'verifyEmail',
    'recoverEmail',
    'verifyAndChangeEmail',
] as const;

export interface FirebaseActionURLParams {
    mode: (typeof VALID_MODES)[number];
    oobCode: string;
    continueUrl?: string;
}

/**
 * Get the firebase action URL params.
 * https://firebase.google.com/docs/auth/custom-email-handler
 */
export function useFirebaseActionURLParams(): FirebaseActionURLParams | null {
    const location = useHistoryLocation();

    return React.useMemo(() => {
        return extractFirebaseActionURLParams(location.search);
    }, [location.search]);
}

/** Extract firebase action from URL. */
function extractFirebaseActionURLParams(search: string): FirebaseActionURLParams | null {
    const searchParams = new URLSearchParams(search);

    const mode = searchParams.get('mode') as (typeof VALID_MODES)[number] | null;
    const oobCode = searchParams.get('oobCode');
    const continueUrl = searchParams.get('continueUrl');

    if (typeof mode !== 'string' || typeof oobCode !== 'string' || !VALID_MODES.includes(mode)) {
        return null;
    }

    return {
        mode,
        oobCode,
        continueUrl: typeof continueUrl === 'string' ? continueUrl : undefined,
    };
}
